// eslint-disable-next-line import/prefer-default-export
export const sendStageAvailable = () => {
  const event = new CustomEvent('stageAvailable', {
    bubbles: true,
    cancelable: true,
  })

  document.dispatchEvent(event)
}
